import { apiClient } from "helpers/api_helper";

export const getAllCompanyData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Company/GetAllCompany`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};